import { BaseAlgorithm } from './BaseAlgorithm';
import { CIDS } from '../../components/ProductsTable/constants';
import { debugLog, rankDebugLogEnable } from './ranking';

export class PowerDiodeAlgorithm extends BaseAlgorithm {
	constructor(usedFilters, filtersState) {
		super(usedFilters, filtersState);
		this.usedFilters = usedFilters;

		this.normVrrm = 425;
		this.normIf = 1665;
		this.normIfsm = 12500;

		this.rankVrrm = 0;
		this.rankIf = 0;
		this.rankIfsm = 0;

		this.weightVrrm = 0.18;
		this.weightIf = 0.16;
		this.weightIfsm = 0.16;

		this.rVrrm = 0;
		this.rIf = 0;
		this.rIfsm = 0;
	}
	logHeadingsToConsole() {
		if (rankDebugLogEnable) {
			console.log('partNumber,part_Vrrm,rVrrm,rankVrrm,part_If,rIf,rankIf,part_Ifsm,rIfsm,rankIfsm,feRank');
		}
	}

	execute(product) {
		debugLog.length = 0;
		debugLog.push(product[CIDS.PART_NUMBER]);

		// ---------------------------------------------Repetitive peak reverse voltage  VRRM (V)---------------------------------------------

		[this.rankVrrm, this.rVrrm] = this.calculateRankSingleSliderGTE(
			CIDS.REPETITIVE_REVERSE_VOLTAGE,
			product,
			this.normVrrm
		);

		// ---------------------------------------------Continuous forward current  IF(ave) (A)---------------------------------------------

		[this.rankIf, this.rIf] = this.calculateRankSingleSliderGTE(CIDS.CONTINUES_FORWARD_CURRENT, product, this.normIf);

		// ---------------------------------------------Forward current surge peak  IFSM Max (A)---------------------------------------------

		[this.rankIfsm, this.rIfsm] = this.calculateRankSingleSliderGTE(
			CIDS.FORWARD_CURRENT_SURGE_PEAK,
			product,
			this.normIfsm
		);

		// -------------------------------------------------------------------------------------------

		let feRank = this.weightVrrm * this.rankVrrm + this.weightIf * this.rankIf + this.weightIfsm * this.rankIfsm;
		let isPunished = false;
		debugLog.push(feRank);

		[feRank, isPunished] = super.punishPartsWithNullValueOfUsedFilters(product, this.usedFilters, feRank);

		let finalRank = (1 - this.weightVrrm - this.weightIf - this.weightIfsm) * super.execute(product) + feRank;

		return isPunished ? finalRank / this.maxRankAfterPunish : finalRank;
	}
}
